<template>
  <div>
    <header-info cur="1"></header-info>
    <div class="main-container hidebox">
      <div class="common-container">
        <div class="common-box">
          <div class="video-container">
            <div class="btns-wrap">
              <button
                :class="videoActive==1?'on':''"
                @click="videoActive=1"
              >教学引导视频</button>
              <button
                :class="videoActive==2?'on':''"
                @click="videoActive=2"
              >项目简介视频</button>
            </div>
            <video
              :src="(videoActive==1? formatVideoPath(formInfo.tech_video, formInfo.tech_resource): formatVideoPath(formInfo.brief_video, formInfo.brief_resource))"
              :poster="formInfo.logo.substr(1,formInfo.logo.length)"
              controls=""
            >您的浏览器不支持Video标签
            </video>
          </div>
          <div class="info-container">
            <h2 :title="formInfo.title">{{ formInfo.title }}</h2>
            <div class="text-style">
              <span>学院：{{ formInfo.academy ? formInfo.academy.title : '' }}</span>
              <span>对应专业大类：{{ formInfo.subject ? formInfo.subject.subject_category.title : '' }}</span>
              <span>对应专业：{{ formInfo.subject ? formInfo.subject.title : '' }}</span>
            </div>
            <div class="text-style">
              <span>负责人教师：{{ formInfo.master_name ? formInfo.master_name : '' }}</span>
              <span>申报级别：{{ formInfo.exp_level ? formatExpLevel(formInfo.exp_level) : '--' }}</span>
              <span>实验已开设期次：{{ formInfo.open_times ? formInfo.open_times : '--' }}</span>
            </div>
            <div class="text-style">
              <span>实验类型：{{ formInfo.exp_type ? $store.state.dict_exp_type[formInfo.exp_type] : '--'}}</span>
              <span>实验语言：{{ formInfo.exp_language ? $store.state.dict_exp_language[formInfo.exp_language] : '--' }}</span>
            </div>
            <div class="text-style">
              <div>虚拟仿真必要性：
                <span v-if="formInfo.necessity && formInfo.necessity.Obj1">高危或极端环境 </span>
                <span v-if="formInfo.necessity && formInfo.necessity.Obj2">高成本、高消耗 </span>
                <span v-if="formInfo.necessity && formInfo.necessity.Obj3">不可逆操作</span>
                <span v-if="formInfo.necessity && formInfo.necessity.Obj4">大型综合训练</span>
                <span v-if="formInfo.necessity && formInfo.necessity.Obj1 =='' && formInfo.necessity.Obj2=='' && formInfo.necessity.Obj3==''">-</span>
              </div>
            </div>
            <div class="text-style">
              <span class="brief-label">实验简介：</span>
              <p class="brief-info">{{ formInfo.brief }}</p>
            </div>
            <div class="action-btn">
              <button
                class="btn-join"
                v-if="audit_status===0"
              >申请中
              </button>
              <button
                class="btn-join"
                v-else
                @click="addPerson"
              >开始实验
              </button>
              <button
                :class="collectInfo?'btn-join':'btn-collect'"
                data="1"
                @click="toCollect"
              >
                <i class="icon iconfont">&#xe66b;</i>收藏
              </button>
              <button
                v-if="parseInt(localUser.role) <= 3 || formInfo.master_id == localUser.profile_id"
                class="btn-join btn-view"
                @click="toViewScore"
              >成绩查看
              </button>
            </div>
            <div class="action-btn btn-wrap-evaluate">
              <button
                class="btn-evaluate"
                @click="showCommentWindow"
              >
                <i class="icon iconfont">&#xe664;</i>实验评价
              </button>
              <div class="star-wrap">
                <i
                  class="icon iconfont"
                  v-for="(term,i) in 5"
                  :key="i"
                >
                  {{ formInfo.appraise_avg > i ? '&#xe67f;' : '&#xe66b;' }}
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="common-statistics">
        <div class="statistics-box">
          <div class="statistics-group">
            <div class="row">实验应用</div>
            <div class="row">
              <div class="col"><i class="icon iconfont">&#xe62a;</i>浏览量：{{ statisticsData.view_count }}</div>
              <div class="col"><i class="icon iconfont">&#xe62d;</i>实验人次：{{ statisticsData.do_count }}</div>
              <div class="col"><i class="icon iconfont">&#xe6a4;</i>实验人数：{{ statisticsData.do_user }}</div>
              <div class="col"><i class="icon iconfont">&#xe6a4;</i>实验点击量：{{ statisticsData.click_count }}</div>
            </div>
            <div class="row">
              <div class="col"><i class="icon iconfont">&#xe606;</i>平均用时：{{ formatSeconds(statisticsData.avg_time) + '\'' }}</div>
              <div class="col"><i class="icon iconfont">&#xe657;</i>实验完成率：{{ '' + statisticsData.finish_percent + '%' }}</div>
              <div class="col"><i class="icon iconfont">&#xe607;</i>实验通过率：{{ '' + statisticsData.pass_percent + '%' }}</div>
              <div class="col"><i class="icon iconfont">&#xe607;</i>实验报告数：{{ statisticsData.report_count }}</div>
            </div>
          </div>
          <div class="statistics-group">
            <div class="row">成绩分布</div>
            <div class="row">
              <div class="level level1">优秀：{{ statisticsData.level1_percent }}%</div>
              <div class="level level2">达标：{{ statisticsData.level2_percent }}%</div>
              <div class="level level3">不达标：{{ statisticsData.level3_percent }}%</div>
            </div>
            <div class="row">
              <div class="grade-bar">
                <div class="bar bar1" :style="'width: ' + statisticsData.level1_percent + '%'"></div>
                <div class="bar bar2" :style="'width: ' + statisticsData.level2_percent + '%'"></div>
                <div class="bar bar3" :style="'width: ' + statisticsData.level3_percent + '%'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="common-menu">
        <ul class="menu-list">
          <li>
            <span
              :class="menuActive==1?'active':''"
              @click="menuActive=1"
            >实验团队</span>
          </li>
          <li>
            <span
              :class="menuActive==2?'active':''"
              @click="menuActive=2"
            >实验描述</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==3?'active':''"
              @click="menuActive=3"
            >支持与服务</span>
          </li>
          <li>
            <span
              :class="menuActive==4?'active':''"
              @click="menuActive=4"
            >网络要求</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==5?'active':''"
              @click="menuActive=5"
            >技术架构</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==6?'active':''"
              @click="menuActive=6"
            >服务计划</span>
          </li>
          <li>
            <span
              :class="menuActive==7?'active':''"
              @click="menuActive=7"
            >实验特色</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==8?'active':''"
              @click="menuActive=8"
            >知识产权</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==9?'active':''"
              @click="menuActive=9"
            >诚信承诺</span>
          </li>
          <li v-if="this.localUser && this.localUser.role < 10">
            <span
              :class="menuActive==10?'active':''"
              @click="menuActive=10"
            >附件材料</span>
          </li>
        </ul>
      </div>
      <div class="components-box">
        <template v-if="menuActive==1">
          <ExperimentalTeam :expId=params.id></ExperimentalTeam>
        </template>
        <template v-if="menuActive==2">
          <ExperimentDes :expId=params.id></ExperimentDes>
        </template>
        <template v-if="menuActive==3">
          <SupportAndServices :expId=params.id></SupportAndServices>
        </template>
        <template v-if="menuActive==4">
          <NetRequire :expId=params.id></NetRequire>
        </template>
        <template v-if="menuActive==5">
          <TechnicalFrame :expId=params.id></TechnicalFrame>
        </template>
        <template v-if="menuActive==6">
          <ServicePlan :expId=params.id></ServicePlan>
        </template>
        <template v-if="menuActive==7">
          <ExperimentalFeatures :expId=params.id></ExperimentalFeatures>
        </template>
        <template v-if="menuActive==8">
          <IntellectualProperty :expId=params.id></IntellectualProperty>
        </template>
        <template v-if="menuActive==9">
          <SincerityPromise :expId=params.id></SincerityPromise>
        </template>
        <template v-if="menuActive==10">
          <Material :expId=params.id></Material>
        </template>
      </div>
    </div>
    <footer-info></footer-info>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classCommentWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div
          class="form_title"
          style="padding-left: 13px;"
        >实验评价
          <span
            class="close-overlay"
            @click="hideCommentWindow"
          ></span>
        </div>
        <div class="form_content">
          <div
            class="score-wrap"
            id="scoreWrap"
          >
            <div class="score-detail">
              <p class="score-text pull-left">{{ formInfo.appraise_avg ? formInfo.appraise_avg : '0' }}</p>
              <div class="pull-left">
                <div class="star-wrap">
                  <i
                    class="iconfont"
                    v-for="(term,i) in 5"
                    :key="i"
                  >
                    {{ formInfo.appraise_avg > i ? '&#xe67f;' : '&#xe66b;' }}
                  </i>
                </div>
              </div>
            </div>
            <button
              :class="commentType?'btn-publish-evaluate':'btn-publish-bg'"
              @click="showDiscussWindow"
            >评分
            </button>
          </div>

        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="pub_form_overlay"
      :style="classDiscussWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">发表评论
          <span
            class="close-overlay"
            @click="hideDiscussWindow"
          ></span>
        </div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>我的评分:</span>
              <div
                class="check-star"
                id="checkStar"
              >
                <span
                  class="star"
                  v-for="(item,index) in 5"
                  :key="index"
                  :class="star>index?'checked':''"
                  @mouseover="hoverStars(index)"
                >
                  <i class="iconfont yes">&#xe67f;</i>
                  <i class="iconfont no">&#xe66b;</i>
                </span>
                <span class="scoreText">{{ commentInfo.grade }}分</span>
              </div>
            </div>

          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideDiscussWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="toComment"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="classShowGradeWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">
          <span @click="classShowGradeWindow={}"></span>
        </div>
        <div class="form_content">
          <div class="f_list">
            <table>
              <tbody>
                <tr class="l_header">
                  <th class="itemStatus">用户名</th>
                  <th class="itemStatus">姓名</th>
                  <th class="itemStatus">性别</th>
                  <th class="itemStatus">学院</th>
                  <th class="itemStatus">专业</th>
                  <th class="itemStatus">学号</th>
                  <th class="itemStatus">实验结果</th>
                  <th class="itemStatus">实验成绩</th>
                  <th class="itemStatus">实验开始时间</th>
                  <th class="itemStatus">实验结束时间</th>
                  <th class="itemStatus">实验用时</th>
                  <th
                    class="action"
                    width="130"
                  >操作
                  </th>
                </tr>
                <tr
                  v-for="item in gradeTableData"
                  :key="item.id"
                >
                  <td class="itemStatus">{{ item.experimentStudent.userprofile.username }}</td>
                  <td class="itemStatus">{{ item.experimentStudent.userprofile.name }}</td>
                  <td class="itemStatus">{{item.experimentStudent.userprofile.gender==0?'女':'男'}}</td>
                  <td class="itemStatus">{{item.experimentStudent.experiment.academy ? item.experimentStudent.experiment.academy.title : ''}}</td>
                  <td class="itemStatus">{{item.experimentStudent.experiment.subject ? item.experimentStudent.experiment.subject.title : ''}}</td>
                  <td class="itemStatus">{{item.experimentStudent.userprofile.s_no}}</td>
                  <td class="itemStatus">{{ item.status ? '完成' : '未完成' }}</td>
                  <td class="itemStatus">{{ item.score }}</td>
                  <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.timeUsed }}</td>
                  <td class="action">
                    <a
                      class="edit"
                      href="javascript:;"
                      @click="viewDetail(item)"
                    >查看详情</a>
                    <br>
                    <a
                      v-if="item.reportStatus == 1"
                      class="edit"
                      href="javascript:;"
                      @click="downloadReport(item)"
                    >下载报告</a>
                    <a
                      v-if="item.reportStatus != 1"
                      class="edit"
                      style="color: #aaaaaa"
                      href="javascript:;"
                    >下载报告</a>
                  </td>
                </tr>
                <tr
                  class="noitems"
                  v-if="!gradeTableData.length"
                >
                  <td colspan="7">没有数据</td>
                </tr>
              </tbody>
            </table>

          </div>
          <!-- 分页 -->
          <pagination
            :cur='pageGradeInfo.page'
            :all='pageGradeInfo.all'
            :totalData="pageGradeInfo.totalData"
            :callback="pageGradeCallback"
          ></pagination>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="classShowDetailWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">详情
          <span @click="classShowDetailWindow={}">X</span>
        </div>
        <div class="form_content">
          <div class="experiment_text">
            <p>姓名：{{ experimentGrade && experimentGrade.experimentStudent ? experimentGrade.experimentStudent.userprofile.name : '' }}</p>
            <p><span>实验开始时间：{{ experimentGrade.startTime }}</span>
              <span>实验结束时间：{{ experimentGrade.endTime }}</span>
              <span>实验用时：{{ experimentGrade.timeUsed }}</span>
            </p>
            <p><span>实验满分：100</span>
              <span>实验得分：{{ experimentGrade.score }}</span>
              <span>实验结果：{{ experimentGrade.status ? '完成' : '未完成' }}</span>
            </p>
          </div>
          <div class="f_list">
            <table>
              <tbody>
                <tr class="l_header">
                  <th class="itemStatus">步骤名称</th>
                  <th class="itemStatus">步骤开始时间</th>
                  <th class="itemStatus">步骤结束时间</th>
                  <th class="itemStatus">步骤用时(秒)</th>
                  <th class="itemStatus">步骤合理用时(秒)</th>
                  <th class="itemStatus">步骤满分</th>
                  <th class="itemStatus">步骤得分</th>
                  <th class="itemStatus">步骤操作次数</th>
                  <th class="itemStatus">步骤评价</th>
                  <th class="itemStatus">赋分模型</th>
                  <th class="itemStatus">备注</th>
                </tr>
                <tr
                  v-for="item in tableStepData"
                  :key="item.id"
                >
                  <td class="itemStatus">{{ item.title }}</td>
                  <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.timeUsed }}</td>
                  <td class="itemStatus">{{ item.expectTime }}</td>
                  <td class="itemStatus">{{ item.maxScore }}</td>
                  <td class="itemStatus">{{ item.score }}</td>
                  <td class="itemStatus">{{ item.repeatCount }}</td>
                  <td class="itemStatus">{{ item.evaluation }}</td>
                  <td class="itemStatus">{{ item.scoringModel }}</td>
                  <td class="itemStatus">{{ item.remarks }}</td>
                </tr>
                <tr
                  class="noitems"
                  v-if="!tableStepData.length"
                >
                  <td colspan="11">没有数据</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import ExperimentalTeam from '../../../components/experiment/ExperimentalTeam'
import ExperimentDes from '../../../components/experiment/ExperimentDes'
import SupportAndServices from '../../../components/experiment/SupportAndServices'
import NetRequire from '../../../components/experiment/NetRequire'
import TechnicalFrame from '../../../components/experiment/TechnicalFrame'
import ServicePlan from '../../../components/experiment/ServicePlan'
import ExperimentalFeatures from '../../../components/experiment/ExperimentalFeatures'
import IntellectualProperty from '../../../components/experiment/IntellectualProperty'
import SincerityPromise from '../../../components/experiment/SincerityPromise'
import Material from '../../../components/experiment/Material'
import Pagination from '../../../components/Pager'
import CryptoJs from 'crypto-js'
export default {
  name: 'ExperimentV2',
  components: {
    HeaderInfo,
    FooterInfo,
    ExperimentalTeam,
    ExperimentDes,
    SupportAndServices,
    NetRequire,
    TechnicalFrame,
    ServicePlan,
    ExperimentalFeatures,
    IntellectualProperty,
    SincerityPromise,
    Material,
    Pagination
  },
  data() {
    return {
      menuActive: 1,
      videoActive: 1,
      params: {
        id: 0,
        ticket: ''
      },
      commentData: [],
      commentDataCount: 0,
      active: 1,
      formInfo: {
        id: 0,
        appraise_avg: '',
        academy: null,
        subject_id: 0,
        subject: null,
        master_id: 0,
        master_name: null,
        title: '',

        url: '',
        isTeacherCheck: 0,
        exp_level: 0,
        brief: '',
        logo: '',

        brief_video: '',
        tech_video: '',
        brief_resource: null,
        tech_resource: null

      },
      classCommentWindow: {},
      classDiscussWindow: {},
      classShowGradeWindow: {},
      collectInfo: true,
      commentInfo: {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        grade: ''
      },
      star: 0,
      queryInfo: {
        page: 1,
        size: 10
      },
      audit_status: '',
      userList: [],
      commentType: true,
      gradeTableData: [],
      gradeTableDataCount: 0,
      queryGradeInfo: {
        page: 1,
        size: 10,
        experiment_id: this.$route.query.id,
        expJoinType: 0
      },
      experimentGrade: {},
      classShowDetailWindow: {},
      tableStepData: [],
      statisticsData: {
        view_count: 0,
        do_count: 0,
        do_user: 0,
        click_count: 0,
        avg_time: 0,
        finish_percent: 0,
        pass_percent: 0,
        report_count: 0,
        level1_percent: 0,
        level2_percent: 0,
        level3_percent: 0
      }
    }
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    },
    formatTime(val) {
      return val ? val.replace('T', ' ') : '--'
    },
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.commentDataCount / this.queryInfo.size),
        totalData: this.commentDataCount
      }
    },
    pageGradeInfo() {
      return {
        page: this.queryGradeInfo.page,
        all: Math.ceil(this.gradeTableDataCount / this.queryGradeInfo.size),
        totalData: this.gradeTableDataCount
      }
    }
  },
  methods: {
    formatExpLevel(value) {
      return value ? this.$store.state.dict_exp_level[value] : '--'
    },
    formatVideoPath(briefVideo, briefResource) {
      if (briefResource && briefResource.status === 3) {
        return '/static/mp4/sd/' + briefResource.newSourceDIR + '/' + briefResource.newSourceID + '.mp4'
      } else {
        return briefVideo.substr(0, briefVideo.length)
      }
    },
    formatSeconds (s) {
      if (!s) {
        return '0'
      }
      const m = Math.ceil(parseInt(s) / 60)
      return '' + m
    },
    getUrlKey(name) {
      const url = window.location.href
      const dzUrl = url.split('#')[0]
      if (dzUrl.split('?').length <= 1) {
        return ''
      }
      const csArr = dzUrl.split('?')[1].split('&')
      const cs = {}
      for (let i = 0; i < csArr.length; i++) {
        cs[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      return cs[name]
    },
    // 获取实验信息
    async getExperimentInfo() {
      const url = '/allowany/experiment/' + this.$route.query.id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = data
        this.formInfo.necessity = data.necessity ? JSON.parse(data.necessity) : {}
        document.title = this.formInfo.title + ''
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取实验统计信息
    async getExperimentStatisticsInfo() {
      const url = '/experiment_index_statistics/'
      await this.$http.get(url, {
        params: {
          id: this.$route.query.id
        }
      }).then((data) => {
        console.log(data)
        if (data.code === '200') {
          this.statisticsData.view_count = data.data.view_count
          this.statisticsData.do_count = data.data.do_count
          this.statisticsData.do_user = data.data.do_user
          this.statisticsData.click_count = data.data.click_count
          this.statisticsData.avg_time = data.data.avg_time
          this.statisticsData.finish_percent = data.data.finish_percent
          this.statisticsData.pass_percent = data.data.pass_percent
          this.statisticsData.report_count = data.data.report_count
          this.statisticsData.level1_percent = data.data.level1_percent
          this.statisticsData.level2_percent = data.data.level2_percent
          this.statisticsData.level3_percent = data.data.level3_percent
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取评论信息
    async getAppraiseInfo() {
      await this.$http.get('/allowany/experimentappraise/', {
        params: {
          experiment_id: this.$route.query.id
        }
      }).then((data) => {
        this.commentData = data.results
        this.commentDataCount = data.count
        this.userList = this.commentData.map(item => item.userprofile_id)
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },
    // 发表评论
    async toComment() {
      if (this.commentInfo.grade === '') {
        this.$layer.msg('请选择评分！')
      }
      this.commentInfo.content = ''
      await this.$http.post('/experimentappraise_save/', this.commentInfo).then((data) => {
        if (data.code === '200') {
          this.commentType = false
          this.getExperimentInfo()
          this.getAppraiseInfo()
          this.hideDiscussWindow()
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },
    // 查询当前用户是否评论过
    async getUserAppraiseInfo() {
      await this.$http.get('/allowany/experimentappraise/', {
        params: {
          experiment_id: this.$route.query.id,
          userprofile_id: this.$store.state.userInfo.profile_id
        }
      }).then((data) => {
        if (data.results.length > 0) {
          if (this.$store.state.userInfo.profile_id === data.results[0].userprofile_id) {
            this.commentType = false
          }
        }
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },
    // 获取实验成绩信息
    async getGradeInfo() {
      await this.$http.get('/allowany/experimentgrade/', {
        params: this.queryGradeInfo
      }).then((data) => {
        this.gradeTableData = data.results
        this.gradeTableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    // 获取收藏状态
    async getCollect() {
      const itemInfo = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        page: 1,
        size: 10000
      }
      await this.$http.get('/allowany/experimentcollect/', {
        params: itemInfo
      }).then((data) => {
        if (data.results.length > 0) {
          if (itemInfo.userprofile_id === data.results[0].userprofile_id) {
            this.collectInfo = false
          }
        }
      })
    },
    // 统计浏览人数
    async viewCount() {
      await this.$http.post('/experiment_view_count/', {
        id: this.$route.query.id
      }).then((data) => {

      }).catch((error) => {
        console.log(error)
      })
    },
    // 将当前用户添加进实验
    async addPerson() {
      if (!this.$store.state.userInfo.profile_id) {
        await this.$router.push('/login')
        return
      }

      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }

      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then(async (data) => {
        if (data.results.length > 0) {
          if (data.results[0].audit_status === 0) {
            this.$layer.msg('等待审核中，请勿重复申请！')
          } else {
            // 跳转链接
            await this.toUrl(data.results[0].id)
            await this.addLog()
          }
        } else {
          await this.$http.post('/experimentstudent_save/', {
            experiment_id: this.$route.query.id,
            userprofile_id: this.$store.state.userInfo.profile_id,
            audit_status: this.formInfo.isTeacherCheck ? 0 : 1,
            is_select: '0',
            expJoinType: '0'
          }).then(async (data) => {
            if (data.code === '200') {
              this.audit_status = data.audit_status
              if (data.audit_status === 0) {
                this.$layer.msg('已提交申请,等待审核中！')
              } else {
                // 跳转链接
                await this.toUrl(data.id)
                await this.addLog()
              }
            } else {
              this.$layer.msg('加入实验失败！')
            }
          }).catch(() => {
            this.$layer.msg('加入实验失败！')
          })
        }
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    },
    async toUrl(experimentStudentId) {
      if (this.formInfo.url) {
        await this.$http.post('/gen_ticket/', {
          user_id: this.$store.state.userInfo.profile_id,
          app_id: this.formInfo.id,
          username: this.$store.state.userInfo.user_name,
          experiment_student_id: experimentStudentId,
          join_type: 0
        }).then(async (data) => {
          if (data.code === '200') {
            if (this.formInfo.url) {
              if (this.formInfo.url.indexOf('?') !== -1) {
                window.open(this.formInfo.url + '&ticket=' + data.ticket + '&u=' + data.user_ticket)
              } else {
                window.open(this.formInfo.url + '?ticket=' + data.ticket + '&u=' + data.user_ticket)
              }
            } else {
              this.$layer.msg('实验路径配置错误，请联系管理员！')
            }
          }
        })
      }
    },
    // 收藏
    async toCollect() {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id
      }
      if (this.collectInfo) {
        this.collectInfo = false
        await this.$http.post('/experimentcollect_save/', params).then((data) => {
          if (data.code === '200') {
            this.$layer.msg('添加收藏成功！')
          } else {
            this.$layer.msg('添加收藏失败！')
          }
        }).catch(() => {
          this.$layer.msg('添加收藏失败！')
        })
      } else {
        this.$layer.msg('已收藏！')
      }
    },
    toViewScore() {
      this.classShowGradeWindow = {
        visibility: 'visible'
      }
    },
    async viewDetail(item) {
      item.startTime = item.startTime.replace('T', ' ')
      item.endTime = item.endTime.replace('T', ' ')
      this.experimentGrade = item
      this.classShowDetailWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/allowany/experimentstep/', {
        params: params
      }).then((data) => {
        this.tableStepData = data.results
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    downloadReport(item) {
      console.log(JSON.parse(item.experimentReport))
      window.open(JSON.parse(item.experimentReport).path)
    },
    pageGradeCallback(data) {
      this.queryGradeInfo.page = data
      this.getGradeInfo()
    },
    showDiscussWindow() {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      if (this.userList.indexOf(this.$store.state.userInfo.profile_id) < 0) {
        this.classDiscussWindow = {
          visibility: 'visible'
        }
      } else {
        this.$layer.msg('您已经评论过了！')
      }
    },
    hideDiscussWindow() {
      this.star = 0
      this.commentInfo.grade = ''
      this.classDiscussWindow = {
        visibility: 'hidden'
      }
    },
    showCommentWindow() {
      this.classCommentWindow = {
        visibility: 'visible'
      }
    },
    hideCommentWindow() {
      this.classCommentWindow = {
        visibility: 'hidden'
      }
    },
    hoverStars(index) {
      this.star = index + 1
      this.commentInfo.grade = this.star
    },
    async addLog() {
      await this.$http.post('/user_log/', {
        userprofile_id: this.$store.state.userInfo.profile_id,
        category: 2,
        content: `实验名称：${this.formInfo.title}`
      }).then(async (data) => {
      }).catch(() => {
        this.$layer.msg('添加日志失败！')
      })
    },
    decryptDes (word) {
      const key = CryptoJs.enc.Utf8.parse('1234567890ABCDEF')
      const decrypt = CryptoJs.AES.decrypt(word, key, {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
      })
      return CryptoJs.enc.Utf8.stringify(decrypt).toString()
    },
    // 手机端点击开始实验将当前用户添加进实验
    async mobileAddPerson() {
      if (!this.$store.state.userInfo.profile_id) {
        await this.$router.push('/login')
        return
      }

      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }

      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then(async (data) => {
        if (data.results.length > 0) {
          if (data.results[0].audit_status === 0) {
            this.$layer.msg('等待审核中，请勿重复申请！')
          } else {
            this.$layer.msg('移动端不支持虚拟仿真实验，请到WEB端进行实验')
            await this.addLog()
          }
        } else {
          await this.$http.post('/experimentstudent_save/', {
            experiment_id: this.$route.query.id,
            userprofile_id: this.$store.state.userInfo.profile_id,
            audit_status: this.formInfo.isTeacherCheck ? 0 : 1,
            is_select: '0',
            expJoinType: '0'
          }).then(async (data) => {
            if (data.code === '200') {
              this.audit_status = data.audit_status
              if (data.audit_status === 0) {
                this.$layer.msg('已提交申请,等待审核中！')
              } else {
                // 跳转链接
                this.$layer.msg('移动端不支持虚拟仿真实验，请到WEB端进行实验')
                await this.addLog()
              }
            } else {
              this.$layer.msg('加入实验失败！')
            }
          }).catch(() => {
            this.$layer.msg('加入实验失败！')
          })
        }
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    }
  },
  mounted() {
    this.viewCount()
    this.getAppraiseInfo()
    this.getUserAppraiseInfo()
    this.getGradeInfo()
    if (this.$store.state.userInfo.profile_id) {
      this.getCollect()
    }
    this.getExperimentInfo()
    this.getExperimentStatisticsInfo()
  },
  async created() {
    this.params.id = this.getUrlKey('id')
    this.params.ticket = this.getUrlKey('ticket')
    if (!this.params.id) {
      this.$router.push('/error?msg=参数错误')
    }
    this.params.id = parseInt(this.params.id)
    // 专家 带ticket登陆
    if (this.params.ticket && !this.$store.state.userInfo.profile_id) {
      const relTicketObj = JSON.parse(this.decryptDes(decodeURIComponent(this.params.ticket)))

      // 登录方法
      await this.$http.post('/api-token-auth/', {
        username: relTicketObj.username,
        password: relTicketObj.password
      }).then(async (data) => {
        if (!data.token) {
          window.localStorage.clear()
        } else {
          window.localStorage.clear()
          this.$store.commit('setToken', data.token)
          await this.$http.post('/login_user/', {}).then(async (data) => {
            this.$store.commit('setUserInfo', data)
          }).catch(() => {
            console.log('专家获取用户信息失败！')
          })
        }
      }).catch(() => {
        console.log('专家账号或密码输入错误！')
      })
    }

    if (this.$store.state.userInfo.profile_id) {
      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }
      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then((data) => {
        if (data.results.length) {
          this.audit_status = data.results[0].audit_status
        }
      }).catch(() => {
        this.$layer.msg('获取团队成员信息失败！')
      })
    }
  }
}
</script>
<style scoped src="../../../assets/css/project-detail.css"></style>
<style lang="less"  scoped>
.main-container {
  min-height: calc(100vh - 287px);
  background: #fff;
  padding-bottom: 30px;
  box-sizing: border-box;
}
.common-container {
  background: url(../../../assets/images/project-detail-banner.png) repeat-x center center;
  padding: 60px;
  box-sizing: border-box;
  .common-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.common-statistics {
  background-color: rgba(242, 242, 242, 1);
  color: #444444;
  font-size: 16px;
  height: 150px;
  .statistics-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .statistics-group {
      flex-grow: 1;
      margin: 25px 0px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      .row {
        flex-grow: 1;
        margin: 5px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .col {
          width: 190px;
          .iconfont {
            color: #0091FF;
            margin-right: 10px;
          }
        }
        .level {
          width: 125px;
        }
        .level1 {
          color: #0091FF;
        }
        .level2 {
          color: #3578AE;
        }
        .level3 {
          color: #FFA500;
        }
        .grade-bar {
          width: 100%;
          .bar {
            display: inline-block;
            height: 25px;
          }
          .bar1 {
            background-color: #0091FF;
          }
          .bar2 {
            background-color: #3578AE;
          }
          .bar3 {
            background-color: #FFA500;
          }
        }
      }
    }
  }
}
.video-container {
  width: 600px;
  height: 340px;
  background: #000;
  position: relative;
  .btns-wrap {
    position: absolute;
    top: 30px;
    text-align: center;
    width: 100%;
    z-index: 9;
    button {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      background: #253331;
      border: 1px solid #73D6CA;
      box-sizing: border-box;
      font-size: 14px;
      color: #fff;
      margin: 0 10px;
      cursor: pointer;
      outline: none;
      &.on {
        background: #73D6CA;
        border-color: #73D6CA;
      }
    }
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.info-container {
  width: 570px;
  height: 340px;
  color: #fff;
  font-size: 12px;
  margin-left: 30px;
  h2 {
    width: 570px;
    font-size: 24px;
    margin-bottom: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .text-style {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 5px;
    span {
      margin-right: 15px;
    }
    .brief-label {
      margin-right: 10px;
    }

    .brief-info {
      text-align: justify;
      width: 450px;
      height: 93px;
      overflow-y: auto;
    }
  }
  .action-btn {
    overflow: hidden;
    margin-top: 10px;
    button {
      padding: 0 20px;
      margin-right: 15px;
      border-radius: 5px;
      height: 40px;
      line-height: 40px;
      border: none;
      font-size: 16px;
      color: #fff;
      float: left;
      cursor: pointer;
      outline: none;
      i {
        font-size: 16px;
        margin-right: 4px;
      }
    }
    .btn-join {
      background: #0091ff;
    }
    .btn-collect {
      background: #aaa;
    }
    .btn-view {
      background: orange;
    }
    .btn-evaluate {
      background: #3578ae;
    }
  }
  .btn-wrap-evaluate {
    margin-top: 20px;
  }
  .star-wrap i {
    font-size: 26px;
    color: #ffcc00;
    margin-right: 5px;
  }
}
.common-menu {
  padding-top: 20px;
  .menu-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    color: #002900;
    overflow: hidden;
    border-bottom: 1px solid #eee;
    li {
      margin-right: 10px;
      span {
        display: block;
        padding: 10px;
        border-bottom: 3px solid transparent;
        cursor: pointer;
        &.active {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }
}
.components-box {
  width: 1200px;
  margin: 30px auto 0;
}
/deep/.team-wrap {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 20px;
    margin-bottom: 20px;
    &:before {
      content: "";
      width: 4px;
      height: 1em;
      background-color: #73D6CA;
      position: absolute;
      left: 0;
      top: 16px;
    }
    .title-btns {
      a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;
        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }
  .list {
    margin-bottom: 20px;
    table {
      table-layout: fixed;
    }
  }
}
/deep/.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
/deep/#res-preview-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid red;
  text-align: center;
  line-height: 20px;
}
/deep/.pdf-region {
  max-height: 560px;
  overflow-y: scroll;
}
/deep/.preview {
  color: #73D6CA;
  cursor: pointer;
}
/deep/.pagecolor {
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  span:hover {
    color: #73D6CA;
    cursor: pointer;
  }
}
/deep/.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
/deep/.content-text {
  margin-bottom: 10px;
  word-break: break-all;
  h3 {
    font-size: 14px;
    color: inherit;
    margin: 5px 0;
    &:first-of-type {
      margin-top: 0;
    }
  }
}
/deep/.content-text,
/deep/.content-title {
  float: left;
}

.btn-publish-bg {
  padding: 0 20px;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
  border: none;
  font-size: 16px;
  color: #fff;
  float: right;
  cursor: pointer;
  outline: none;
  background: #aaa;
}
.f_list .l_header th {
  padding: 15px 0;
}
.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  background: #ff8383 repeat scroll 0 0;
  color: #ff8383;
  cursor: pointer;
  height: 30px;
  line-height: 28px;
  text-align: center;
  width: 30px;
  font-size: 24px;
  border-radius: 3px;
  overflow: hidden;
}

.form_title span::before {
  content: "×";
  display: block;
  width: 30px;
  height: 30px;
  font-family: 宋体;
  color: rgb(255, 255, 255);
}
.form_panel_item {
  width: 1200px;
  max-width: none;
  margin: 0;
  transform: translate(-50%, -50%);
}
.form_title {
  position: relative;
  margin-bottom: 20px;
}
/deep/.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
/deep/.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
/deep/.check-label-block {
  display: block;
}
</style>
